<template>
  <!-- BEGIN SIDEBAR -->
  <div class="page-sidebar-wrapper">
    <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
    <!-- DOC: Change data-auto-speed="200" to adjust the sub menu slide up/down speed -->
    <div class="page-sidebar navbar-collapse collapse">
      <!-- BEGIN SIDEBAR MENU -->
      <!-- DOC: Apply "page-sidebar-menu-light" class right after "page-sidebar-menu" to enable light sidebar menu style(without borders) -->
      <!-- DOC: Apply "page-sidebar-menu-hover-submenu" class right after "page-sidebar-menu" to enable hoverable(hover vs accordion) sub menu mode -->
      <!-- DOC: Apply "page-sidebar-menu-closed" class right after "page-sidebar-menu" to collapse("page-sidebar-closed" class must be applied to the body element) the sidebar sub menu mode -->
      <!-- DOC: Set data-auto-scroll="false" to disable the sidebar from auto scrolling/focusing -->
      <!-- DOC: Set data-keep-expand="true" to keep the submenues expanded -->
      <!-- DOC: Set data-auto-speed="200" to adjust the sub menu slide up/down speed -->
      <ul class="page-sidebar-menu " data-keep-expanded="false" data-auto-scroll="true" data-slide-speed="200">
        <!-- DOC: To remove the sidebar toggler from the sidebar you just need to completely remove the below "sidebar-toggler-wrapper" LI element -->
        <li class="sidebar-toggler-wrapper">
          <!-- BEGIN SIDEBAR TOGGLER BUTTON -->
          <div class="sidebar-toggler">
          </div>
          <!-- END SIDEBAR TOGGLER BUTTON -->
        </li>
        <!-- DOC: To remove the search box from the sidebar you just need to completely remove the below "sidebar-search-wrapper" LI element -->
        <li class="sidebar-search-wrapper">
          <!-- BEGIN RESPONSIVE QUICK SEARCH FORM -->
          <!-- DOC: Apply "sidebar-search-bordered" class the below search form to have bordered search box -->
          <!-- DOC: Apply "sidebar-search-bordered sidebar-search-solid" class the below search form to have bordered & solid search box -->
          <form class="sidebar-search " action="#" method="POST">
            <a href="javascript:;" class="remove">
            <i class="icon-close"></i>
            </a>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <span class="input-group-btn">
              <a href="javascript:;" class="btn"><i class="icon-magnifier"></i></a>
              </span>
            </div>
          </form>
          <!-- END RESPONSIVE QUICK SEARCH FORM -->
        </li>
        <li class="start open" :class="{active: ui.activeMenu === 'intro'}" id="intro">
          <a href="javascript:;">
          <i class="icon-home"></i>
          <span class="title">概况</span>
          <span class="selected"></span>
          <span class="arrow open"></span>
          </a>
          <ul class="sub-menu">
            <li :class="{active: ui.activeSubmenu === 'info'}" id="info">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/" data-ancestor="intro" data-parent="info">
              <i class="icon-bar-chart"></i>
              关于平台</a>
            </li>
          </ul>
        </li>
        <!-- <li v-if="auth(['ad_app_list','ad_position_list','ad_advertiser_list','ad_campaign_list','ad_advertisement_list'])" :class="{active: ui.activeMenu === 'ad'}" id="ad">
          <a href="javascript:;">
          <i class="icon-wallet"></i>
          <span class="title">广告平台</span>
          <span class="selected"></span>
          <span class="arrow "></span>
          </a>
          <ul class="sub-menu">
            <li name="ad" v-if="auth('ad_app_list')" id="ad_app_list" :class="{active: ui.activeSubmenu == 'ad_app_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/app" data-ancestor="ad" data-parent="ad_app_list">
              <i class="fa fa-tablet"></i>
              投放端</a>
            </li>
            <li v-if="auth('ad_position_list')" id="ad_position_list" :class="{active: ui.activeSubmenu == 'ad_position_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/adposition" data-ancestor="ad" data-parent="ad_position_list">
              <i class="icon-handbag"></i>
              推广位</a>
            </li>
            <li name="ad" v-if="auth('ad_advertiser_list')" id="ad_advertiser_list" :class="{active: ui.activeSubmenu == 'ad_advertiser_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/advertiser" data-ancestor="ad" data-parent="ad_advertiser_list">
              <i class="icon-basket"></i>
              广告主</a>
            </li>
            <li v-if="auth('ad_campaign_list')" id="ad_campaign_list" :class="{active: ui.activeSubmenu == 'ad_campaign_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/campaign" data-ancestor="ad" data-parent="ad_campaign_list">
              <i class="icon-tag"></i>
              推广计划</a>
            </li>
            <li v-if="auth('ad_advertisement_list')" id="ad_advertisement_list" :class="{active: ui.activeSubmenu == 'ad_advertisement_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/advertisement" data-ancestor="ad" data-parent="ad_advertisement_list">
              <i class="icon-pencil"></i>
              广告创意</a>
            </li>
          </ul>
        </li>
        <li v-if="auth(['dmp_campaign_list','dmp_advertisement_list'])" :class="{active: ui.activeMenu === 'dmp'}" id="dmp">
          <a href="javascript:;">
          <i class="icon-diamond"></i>
          <span class="selected"></span>
          <span class="title">数据平台</span>
          <span class="arrow "></span>
          </a>
          <ul class="sub-menu">
            <li v-if="auth('dmp_campaign_list')" id="dmp_campaign_list" :class="{active: ui.activeSubmenu === 'dmp_campaign_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/dmpcampaign" data-ancestor="dmp" data-parent="dmp_campaign_list">
                <i class="icon-globe"></i>
              广告计划</a>
            </li>
            <li v-if="auth('dmp_advertisement_list')" :class="{active: ui.activeSubmenu === 'dmp_advertisement_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/dmpadvertisement" data-ancestor="dmp" data-parent="dmp_advertisement_list">
                <i class="fa fa-empire"></i>
              创意</a>
            </li>
            <li v-if="auth('dmp_user')" :class="{active: ui.activeSubmenu === 'dmp_user'}">
              <a href="">
                <i class="icon-user"></i>
              用户</a>
            </li>
          </ul>
        </li> -->
        <li  class="last" :class="{active: ui.activeMenu === 'sys'}">
          <a href="javascript:;">
          <i class="fa fa-cogs"></i>
          <span class="selected"></span>
          <span class="title">系统管理</span>
          <span class="arrow "></span>
          </a>
          <ul class="sub-menu">
            <li v-if="auth('sys_role_list')" :class="{active: ui.activeSubmenu === 'sys_role_list'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/role" data-ancestor="sys" data-parent="sys_role_list">
                <i class="icon-user"></i>
              角色</a>
            </li>
            <li v-if="auth('sys_account_list')" :class="{active: ui.activeSubmenu === 'sys_account_list'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/account" data-ancestor="sys" data-parent="sys_account_list">
                <i class="icon-users"></i>
              账号</a>
            </li>
            <li :class="{active: ui.activeSubmenu === 'sys_account_changepwd'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/pwd" data-ancestor="sys" data-parent="sys_account_changepwd">
                <i class="fa fa-lock"></i>
              修改密码</a>
            </li>
            <!-- <li v-if="isSuper()" :class="{active: ui.activeSubmenu === 'sys_permission'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/permission" data-ancestor="sys" data-parent="sys_permission">
                <i class="icon-notebook"></i>
              权限功能</a>
            </li>
            <li v-if="isSuper()"  :class="{active: ui.activeSubmenu === 'sys_apiacs'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/apiacs" data-ancestor="sys" data-parent="sys_apiacs">
                <i class="icon-user-following"></i>
              API授权</a>
            </li> -->
          </ul>
        </li>
        <!-- <li v-if="isSuper()"  :class="{active: ui.activeMenu === 'portrait'}">
          <a href="javascript:;">
          <i class="icon-puzzle"></i>
          <span class="selected"></span>
          <span class="title">用户画像</span>
          <span class="arrow "></span>
          </a>
          <ul class="sub-menu">
            <li v-if="isSuper()" :class="{active: ui.activeSubmenu === 'bigdata_meta_installedapp_list'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/bigdataapp" data-ancestor="portrait" data-parent="bigdata_meta_installedapp_list">
                <i class="fa fa-database"></i>
              已安装采集</a>
            </li>
            <li v-if="isSuper()" :class="{active: ui.activeSubmenu === 'bigdata_meta_tag_list'}">
              <a href="javascript:void(0);" @click="clickMenu" data-path="/#/userprofile" data-ancestor="portrait" data-parent="bigdata_meta_tag_list">
                <i class="icon icon-users"></i>
              画像</a>
            </li>
          </ul>
        </li> -->
        <li v-if="auth(['biz_lock_list','biz_log_list', 'biz_addr_list', 'biz_lift_list'])"  class="last" :class="{active: ui.activeMenu === 'lock'}" id="lock">
          <a href="javascript:;">
          <i class="fa fa-indent"></i>
          <span class="selected"></span>
          <span class="title">设备管理</span>
          <span class="arrow "></span>
          </a>
          <ul class="sub-menu">
            <li v-if="auth('biz_lock_list')" id="biz_lock_list" :class="{active: ui.activeSubmenu === 'biz_lock_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/lock" data-ancestor="lock" data-parent="biz_lock_list">
                <i class="fa fa-plug"></i>
              iKEY设备</a>
            </li>
            <li v-if="auth('biz_lift_list')" id="biz_lift_list" :class="{active: ui.activeSubmenu === 'biz_lift_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/lift" data-ancestor="lock" data-parent="biz_lift_list">
                <i class="fa fa-circle-o"></i>
              梯控设备</a>
            </li>
            <li v-if="auth('biz_liftbtn_list')" id="biz_liftbtn_list" :class="{active: ui.activeSubmenu === 'biz_liftbtn_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/liftbtn" data-ancestor="lock" data-parent="biz_liftbtn_list">
                <i class="fa fa-arrow-circle-o-up"></i>
              呼梯按键</a>
            </li>
            <li v-if="auth('biz_addr_list')" :class="{active: ui.activeSubmenu === 'biz_addr_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/addr" data-ancestor="lock" data-parent="biz_addr_list">
                <i class="fa fa-map-marker"></i>
              地址管理</a>
            </li>
            <li v-if="auth('biz_log_list')" :class="{active: ui.activeSubmenu === 'biz_log_list'}">
              <a href="javascript:void(0)" @click="clickMenu" data-path="/#/log" data-ancestor="lock" data-parent="biz_log_list">
                <i class="fa fa-calendar"></i>
              监控日志</a>
            </li>
          </ul>
        </li>
      </ul>
      <!-- END SIDEBAR MENU -->
    </div>
  </div>
  <!-- END SIDEBAR -->
</template>
<script>
  import commonMethods from '../../lib/methods/common.js'
  export default {
    data () {
      return {
        ui: {
          activeMenu: 'intro',
          activeSubmenu: 'info'
        }
      }
    },
    methods: {
      // dom event handlers, start
      clickMenu (event) {
        this.ui.activeSubmenu = event.target.dataset.parent
        this.ui.activeMenu = event.target.dataset.ancestor
        window.location.href = event.target.dataset.path
      },
      // dom event handlers, end
      ...commonMethods
    }
  }
</script>


// WEBPACK FOOTER //
// sidebar.vue?e7b8e926